import axios from 'axios';

class FinanceService {
  bulkUpdate(data) {
    return axios.post('/finance/intake/bulk', data);
  }

  deleteUserTeamIntake(id) {
    return axios.delete(`/finance/intake/${id}`);
  }

  getAllUsers() {
    return axios.get('/finance/intake/user-records');
  }

  generateFinance() {
    return axios.post('/finance/generateRecords');
  }

  financeRecordsForIntake(data) {
    return axios.post(`/finance/recordsForIntake/`, data);
  }
}

export default new FinanceService();
